module.exports = __webpack_public_path__ + "static/media/carousel_analytics_screenshot_7.b03c475d.png";